import { getUniqueCodeValueByTid, useAppSelector } from '@shalina-app/shared';

export function useContentTypeUniqueCode(articleTypeId?: string) {
    // this hook is always called
    const fallback = useAppSelector(
      getUniqueCodeValueByTid('CONTENT_TYPE', articleTypeId ?? '')
    );
    return fallback;
}